module.exports = __webpack_public_path__ + "img/users-white.81086706.svg";